export default "__VITE_ASSET__B98Y8BXt__"